import script from "./MetasCompartilhadasFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./MetasCompartilhadasFormView.vue?vue&type=script&setup=true&lang=js"

import "./MetasCompartilhadasFormView.vue?vue&type=style&index=0&id=4723b1de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4723b1de"]])

export default __exports__